import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enJSON from './locale/en/en.json'
import frJSON from './locale/fr/fr.json'
i18n.use(initReactI18next).init({
    resources: {
        en: { ...enJSON },
        fr: { ...frJSON },
    }, // Where we're gonna put translations' files
    lng: 'en', // Set the initial language of the App
})
